<template>
<m-pageframe
    title="Bulk Message Templates"
>
<v-container
    fluid
>
    
    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            v-if="$rc.$state.isAuthActorSystemAdmin()"
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickCreateTemplate"
                >
                    <v-list-item-title>Create New Template...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-row>
        <v-col
            v-if="$rc.$state.isAuthActorSystemAdmin()"
        >
            <v-select
                label="Industry"
                :items="$rc.enumChoices('industry_code', true, 'Any Industry')"
                v-model="industry"
                v-on:change="doUpdate"
            />
        </v-col>
        <v-col
            v-if="$rc.$state.isAuthActorSystemAdmin()"
        >
            <v-select
                label="State"
                :items="$rc.enumChoices('bulk_message_template_state', true, 'Any State')"
                v-model="state"
                v-on:change="doUpdate"
            />
        </v-col>
        <v-col
            v-if="$rc.$state.isAuthActorSystemAdmin()"
        >
            <v-select
                label="Type"
                :items="$rc.enumChoices('bulk_message_template_type', true, 'Any Type')"
                v-model="type"
                v-on:change="doUpdate"
            />
        </v-col>
    </v-row>


    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
        v-on:click:row="onClickRow"
    >
    
        <template v-slot:item.message="{ item }">
            <div v-html="prettyMessage(item)"/>
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
            
                <v-list-item
                    v-on:click="onClickRow(item)"
                    v-if="$rc.$state.isAuthActorSystemAdmin()"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <m-create-bulk-message-from-template-dialog
        ref="create_dialog"
    />

    <m-edit-bulk-message-template-dialog
        ref="edit_dialog"
        v-on:input="doUpdate"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            state: 'any_enum_value',
            industry: 'any_enum_value',
            type: 'any_enum_value',

            results: [],

            full_text: null,
        }
    },

    mounted () {
        if ( this.$route.query.admin )
        {
            this.state = 'any_enum_value';
            this.industry = 'any_enum_value';
        }

        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            let state = this.state == 'any_enum_value' ? null : this.state;
            let industry_filter = this.industry == 'any_enum_value' ? null : { 'type': 'includes-any', values: [this.industry] } ;

            let types_filter = this.type == 'any_enum_value' ? null : { 'type': 'includes-any', values: [this.type] } ;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/bulk/templates',
            
                'params' : {
                        'state': state,
                        'industries': industry_filter,
                        'types': types_filter,
                        'full_text': this.full_text,
                        'sort': 'label:asc',
                    },
            
                'on_success': (data) => {
                        this.results = data.results
                    },
            
                'on_error': 'Unable to search bulk message templates',
            });
        },

        onClickRow(item)
        {
            this.$refs['edit_dialog'].showDialog(item.template_id);
        },

        prettyMessage(item)
        {
            if ( item.message_patterns.length == 0 )
                return null;

            return this.$rc.wrapHTML(item.message_patterns[0], false);
        },
        

        onClickCreateTemplate() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/bulk/templates/create-new-stub-template',
            
                'params' : {
                    },
            
                'on_success': (data) => {
                        this.$refs['edit_dialog'].showDialogCreate(data);
                    },
            
                'on_error': 'Unable to create new template',
            });
        },

        onClickEdit(item) {
            window.open(this.$router.resolve({
                'name': 'edit-bulk-message-template',
                'params' : {
                    'template_id': item.template_id,
                }
            }).href, '_blank');
        },
    },

    computed: {
        

        headers()
        {
            let ret = [];

            if ( this.$rc.$state.isAuthActorSystemAdmin() ) 
            {
                ret.push({ text: 'Industries', value: 'industries'});
                ret.push({ text: 'State', value: 'state'});
            }

            ret.push({ text: 'Types', value: 'types'});
            ret.push({ text: 'Label', value: 'label'});
            ret.push({ text: 'Message', value: 'message'});
            ret.push({ text: 'Action', value: 'action'});

            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>